import styled from 'styled-components';
import { IStyledHeader } from './Hero.interface';

export const StyledHeader = styled('h1')<IStyledHeader>(({ font }) => ({
  fontFamily: font,
}));
